import { Box, css } from '@mui/material'
import styled from '@emotion/styled'

export const FiltersContainer = styled(Box)`
  display: flex;
  align-items: flex-end;
  gap: 20px;
`

export const InputsWrapper = styled(Box)`
  display: flex;
  align-items: flex-end;
  gap: 10px;
`

export const SelectWrapper = styled(Box)`
  width: 300px;
  min-width: 300px;
  max-width: 300px;
`

export const FilterButtons = styled(Box)`
  ${({ theme }) => css`
    display: flex;
    align-items: flex-end;
    gap: 10px;

    @media (max-width: ${theme.screenSizes.laptop}) {
      margin-top: 16px;
      flex-direction: column-reverse;
      align-items: center;
    }
  `}
`
